export interface client_file {
  id: string;
  scan_id: string;
  type: string;
  name: string;
  path: string;
  dirs: string[];
  parent_dir: string;
  created: number;
  modified: number;
  size: number;
}

export interface action {
  id?: string;
  uuid?: string;
  created?: number;
  modified?: number;
  completed?: number;
  status?: string;
  type?: string;
  action?: string;
  path?: string;
  sub_folder?: null;
  args?: string;
  run_with?: string;
  log?: string;
  nmap_option?: { scan_type?: string; intensity?: number } | null;
  // Brute force specific fields
  us?: string;
  ps?: string;
  ip?: string;
  option?: string;
  upload_filename?: string;
  upload_password?: string;
}

export interface extension_bucket {
  key: string;
  doc_count: number;
}

export interface dir {
  name: string;
  path: string;
}

export type file_action = "delete" | "rename" | "download" | "execute";

export function parse_windows_path(windows_path?: string): dir[] {
  if (!windows_path) {
    return [];
  }

  // 1. Split the path by the backslash (\) separator.
  // The drive letter (e.g., "C:") will be the first element.
  const all_components = windows_path.split(/\\/g);

  // 2. Filter out any empty strings that might result from
  // paths starting or ending with a backslash (e.g., "C:\\" -> ["C:", ""]).
  const valid_components = all_components.filter(
    (component) => component.length > 0,
  );

  // 3. Process the valid components to build the final structure.
  const result: dir[] = [];
  let current_path = "";

  for (const component of valid_components) {
    if (component.endsWith(":")) {
      // This is the drive letter (e.g., "C:").
      current_path = component;
    } else if (current_path === "" && component.length > 0) {
      // This handles cases like a relative path that doesn't start with a drive (e.g., "folder\sub")
      // or a network path like "\\server" which, depending on split, might need special handling.
      // For standard Windows paths, this case will usually not be hit after the drive letter.
      current_path = component;
    } else {
      // This is a subfolder. Append the backslash and the component name.
      current_path += "\\" + component;
    }

    // Add the component name and the full path to the result array.
    result.push({
      name: component,
      path: current_path,
    });
  }

  return result;
}
